module.exports=function(scope){ return `<uses-permission android:name="android.permission.CAMERA" /> 
<uses-permission android:name="android.permission.INTERNET"/> 
<uses-permission android:name="android.permission.ACCESS_NETWORK_STATE"/> 
<uses-permission android:name="android.permission.ACCESS_WIFI_STATE"/>
`};


// WEBPACK FOOTER //
// ./src/resources/code/quickstart/android/16-permission.java.tpl